import AgoraRTC from 'agora-rtc-sdk-ng';
import logger from '@/modules/Logger';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';

export default {
  // create camera tracks and hide any errors in the user view
  async createCameraTracks() {
    const meta = buildJoinMeta({ provider: 'agora', lessonId: this.lessonId });

    logger.info(
      `${joinPrefix('Agora')} Creating camera track (videoEffect: ${this.videoEffect})`,
      meta
    );

    try {
      this.localVideoTrack?.close();
      // The VB processor pipe is bound to the specific track instance we just
      // closed. Creating a new track invalidates that pipe, so reset the flag —
      // otherwise ensureVbPipelined() short-circuits on the stale `true` and the
      // new track is published unprocessed (blur silently disappears on a
      // device refresh via publishStreamToChannel).
      this.vbPipelined = false;
      this.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
        encoderConfig: this.videoProfile,
        cameraId: this.constraints.cameraId
      });
      this.localTracks.push(this.localVideoTrack);

      logger.info(
        `${joinPrefix('Agora')} Camera track created`,
        meta
      );
    } catch (err) {
      logger.debug('[Agora] Error on getting camera track', { operation: 'webrtc:camera', err: err });

      logger.warn(
        `${joinPrefix('Agora')} Camera track creation failed - ${err.message}`,
        meta
      );
    }
  }
}
